var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 83.366 79.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16798",
    "data-name": "Group 16798",
    transform: "translate(-1272 -4249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32472",
    "data-name": "Path 32472",
    d: "M34.253,2A19.253,19.253,0,1,0,53.506,21.253,19.253,19.253,0,0,0,34.253,2Z",
    transform: "translate(1257 4247)",
    fill: "#ffd2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16797",
    "data-name": "Group 16797",
    transform: "translate(-82.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32550",
    "data-name": "Path 32550",
    d: "M55.662,80.871a1.252,1.252,0,0,1,.164.17,33.867,33.867,0,0,0,11.426,7.8,34.9,34.9,0,0,0,16.6-14.584,38.045,38.045,0,0,0,5-21.624A39.483,39.483,0,0,1,76.8,49.629a38.531,38.531,0,0,1-9.549-5.83,39,39,0,0,1-21.6,8.838,38.044,38.044,0,0,0,5,21.624A35.757,35.757,0,0,0,55.662,80.871Zm-1.31,2.172H21.407A3.414,3.414,0,0,1,18,79.636V21.424a3.414,3.414,0,0,1,3.407-3.407H49.842a1.229,1.229,0,0,1,.879.368L62.572,30.235a1.229,1.229,0,0,1,.361.872V43.977a36.6,36.6,0,0,0,3.511-2.718,1.229,1.229,0,0,1,1.627.008,36.529,36.529,0,0,0,22.01,8.99,1.231,1.231,0,0,1,1.16,1.137h0A40.7,40.7,0,0,1,85.97,75.5,37.313,37.313,0,0,1,67.691,91.311a1.222,1.222,0,0,1-.887,0,36.162,36.162,0,0,1-12.452-8.264Zm6.114-37.525a36.481,36.481,0,0,1-15.984,4.735,1.232,1.232,0,0,0-1.218,1.141A40.709,40.709,0,0,0,48.535,75.5a38.1,38.1,0,0,0,3.572,5.073h-30.7a.947.947,0,0,1-.94-.94V21.424a.947.947,0,0,1,.94-.94h27.2v8.45a3.414,3.414,0,0,0,3.407,3.407h8.45V45.518Zm-31.9,6.79h9.947a1.233,1.233,0,1,0,0-2.467H28.563a1.233,1.233,0,1,0,0,2.467Zm0-6.758a1.233,1.233,0,0,1,0-2.467H52.371a1.233,1.233,0,0,1,0,2.467Zm0-6.758H52.371a1.233,1.233,0,0,0,0-2.467H28.563a1.233,1.233,0,0,0,0,2.467Zm30.16-8.917-7.646-7.646v6.706a.947.947,0,0,0,.94.94Z",
    transform: "translate(1346.188 4236.41)",
    fill: "#2a3d57",
    stroke: "#2a3d56",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32551",
    "data-name": "Path 32551",
    d: "M63.854,67.546c-.506-2.443-2.322-11.457-2.322-14.375a4.4,4.4,0,0,1,6.013-4.179,4.511,4.511,0,0,1,2.761,4.179c0,2.9-1.857,12.181-2.332,14.428a2.062,2.062,0,0,1-3.609,1.027,2.354,2.354,0,0,1-.512-1.08h0Zm.9-5.187a77.938,77.938,0,0,1-1.332-9.188,2.647,2.647,0,0,1,.79-1.907,2.486,2.486,0,0,1,4.2,1.907c0,2.72-1.853,12-2.288,14.036-.061.285-.3.423-.419-.016Zm1.163,7.408a2.874,2.874,0,1,1-2.874,2.874A2.877,2.877,0,0,1,65.918,69.767Zm.695,2.179a.983.983,0,1,1-1.071-.213.983.983,0,0,1,1.071.213Z",
    transform: "translate(1347.521 4240.494)",
    fill: "#2a3d57",
    stroke: "#2a3d56",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureNetwork);
export default __webpack_public_path__ + "static/media/SecureNetwork.5f0a2e45c39f29038a17a46bde92c055.svg";
export { ForwardRef as ReactComponent };